<div class="container">
  <div class="row">
    <div class="col">
      <h3>Exportação Solicitações de Honra</h3>
    </div>
  </div>

    <div ngbAccordion>
      <div ngbAccordionItem>
        <div ngbAccordionHeader>
          <div class="d-flex justify-content-between">
              <button class="title" ngbAccordionButton>Informar Janela de Envio</button>
          </div>
        </div>
  
        <div ngbAccordionCollapse>
        <div ngbAccordionBody>
        <ng-template>
          <div class="row">

            <div class="bn-form-group col-md-3">
              <label for="janela">Janela de envio: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                ngbTooltip="Nome da janela de envio em formato Mês/Ano (MM/AAAA)"></i></label>
              <input type="text" class="form-control" bnMask="MESANO" ngDefaultControl
              [(ngModel)]="janela">
            </div>
  
          </div>
  
          <div class="row">
  
            <div class="submit col-auto">
            <button type="button" class="btn btn-light no-margin" ngbTooltip="Exporta as solicitações de honra da janela informada ou estando vazio irá exportar todas as solicitações." (click)="exportarHonras()">Exportar Solicitações</button>
            </div>
  
            <div class="submit col-auto">
              <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
            </div>
  
          </div>
        </ng-template>
      </div>
      </div>
      </div>
    </div>
</div>
